export default __webpack_public_path__ + "static/media/English.1850aa4e.gif";